import { render, staticRenderFns } from "./servicerMessage.vue?vue&type=template&id=c75ca58c&scoped=true"
import script from "./servicerMessage.vue?vue&type=script&lang=js"
export * from "./servicerMessage.vue?vue&type=script&lang=js"
import style0 from "./servicerMessage.vue?vue&type=style&index=0&id=c75ca58c&prod&lang=css"
import style1 from "./servicerMessage.vue?vue&type=style&index=1&id=c75ca58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75ca58c",
  null
  
)

export default component.exports